import { Service } from "@roc/feature-app-core";

const url = {
  INTERNAL_VALUATION_DASHBOARD: '/api/v1/loan/internalValuation/dashboard',
  INTERNAL_VALUATION_PROGRAM_DASHBOARD: '/api/v1/loan/internalValuation/internalValuationProgramDashboard',
  INTERNAL_VALUATION_TASKS_DASHBOARD: '/api/v1/loan/internalValuation/tasksDashboard',
  INTERNAL_VALUATION_PROGRAM_TASKS_DASHBOARD: '/api/v1/loan/internalValuation/internalValuationProgramTasksDashboard',
  DISPUTE_SECOND_APPRAISAL_TASKS: '/api/v1/loan/internalValuation/getDisputeSecondAppraisalDashboard',
  PATCH_SPECIALISTS_DROPDOWN: '/nportal/rest/priv/loan/{{loanId}}/loanActors',
  BULK_UPDATE_LOAN_ACTORS: '/nportal/rest/priv/loanActors/bulkUpdateLoanActors',
  FETCH_PAYMENT_LINK: '/api/v1/roc-valuation/getValuationPaymentInfo',
  INTERNAL_REQUEST_APPRAISAL_PAYMENT: '/api/v1/loan/internalValuation/sendEmailToBorrower',
  RENTAL_RISK_PROFILER_REVIEW_DASHBOARD: '/api/v1/loan/internalValuation/tasksRentalRiskProfilerDashboard',
  DISPUTE_APPRAISAL_DASHBOARD: '/api/v1/loan/internalValuation/getDisputeAppraisalDashboard',
};

export class InternalValuationService extends Service {
  url;
  constructor() {
    super();
    this.url = url;
  }

  sendEmailToBorrowerPaymentLink = (entityId: any, type: string) => {
    return this.get(url.INTERNAL_REQUEST_APPRAISAL_PAYMENT, {
      entityId,
      type,
    });
  };

  fetchPaymentLink(loanId: any) {
    return this.get(this.url.FETCH_PAYMENT_LINK + "?loanId=" + loanId);
  }

  getInternalValuationDashboard(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
  ) {
    return this.get(this.url.INTERNAL_VALUATION_DASHBOARD,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getInternalValuationProgramDashboard(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
  ) {
    return this.get(this.url.INTERNAL_VALUATION_PROGRAM_DASHBOARD,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getDisputeSecondAppraisalTasks(
    start: number,
    count: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
  ) {
    return this.get(this.url.DISPUTE_SECOND_APPRAISAL_TASKS,
      {
        start,
        count,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  updateValuationReviewer(
    loanId: number,
    { valuationReviewerId }: { valuationReviewerId?: number | null } = {}
  ) {
    return this.put(
      url.PATCH_SPECIALISTS_DROPDOWN.replace('{{loanId}}', `${loanId}`),
      { valuationReviewerId }
    )
  }

  bulkUpdateLoansValuationReviewer(
    loanIds: number[],
    valuationReviewerId: number
  ) {
    const loanActors = loanIds.reduce((acc, loanId) => {
      acc[loanId] = { valuationReviewerId: +valuationReviewerId };
      return acc;
    }, {} as Record<number, { valuationReviewerId: number }>);

    return this.put(url.BULK_UPDATE_LOAN_ACTORS, { loanActors });
  }

  getInternalValuationTasksDashboard(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
  ) {
    return this.get(this.url.INTERNAL_VALUATION_TASKS_DASHBOARD,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getRentalRiskTasksDashboard(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
  ) {
    return this.get(this.url.RENTAL_RISK_PROFILER_REVIEW_DASHBOARD,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getDisputeAppraisalDashboard(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
  ) {
    return this.get(this.url.DISPUTE_APPRAISAL_DASHBOARD,
      { page, pageSize, sortDir, sortBy, filters, dropdownFilters },
      { disableGlobalLoading: true }
    );
  }

  getInternalValuationProgramTasksDashboard(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
  ) {
    return this.get(this.url.INTERNAL_VALUATION_PROGRAM_TASKS_DASHBOARD,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }
}
